
const INITIAL_TABS = [
  {
    id: "idType",
    label: "Select Id Type",
  },
  {
    id: "generalInformation",
    label: "General Information",
  },
  {
    id: "residentialDetails",
    label: "Address Details",
  },
  {
    id: "uploadDocuments",
    label: "File Upload",

  },
  {
    id: "professionalDocuments",
    label: "Professional Documents",
  },
  {
    id: "RolesAndPermissions",
    label: "Roles and Permissions",
  },
];
export { INITIAL_TABS };
